import { Link } from 'react-router-dom'
import './article.css'

const isDirectUrl = (value = '') => /^(?:https?:\/\/|\/)/i.test(value)

const isExternalUrl = (value = '') => /^https?:\/\//.test(value)

const isAssetFile = (value = '') => value.startsWith('assets/files/')

const resolveAssetPath = (assetPath) => {
  // Si es un archivo (PDF, etc), retornar como ruta pública
  if (isAssetFile(assetPath)) {
    return `/${assetPath}`
  }
  
  // Si es una imagen, usar require
  const resolvedAsset = require(`../../${assetPath}`)
  return resolvedAsset?.default || resolvedAsset
}

const formatDateES = (dateString) => {
  return new Intl.DateTimeFormat('es-ES', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).format(new Date(dateString))
}

export default function Article({ imgUrl, title, url, category, date, fromCategory }) {
  const imageSrc = resolveAssetPath(imgUrl)
  
  // Resolver linkHref
  let linkHref = url
  let isExternal = false

  if (!isDirectUrl(url)) {
    if (isAssetFile(url)) {
      linkHref = `/${url}`
    } else {
      linkHref = resolveAssetPath(url)
    }
  } else if (isExternalUrl(url)) {
    isExternal = true
  }

  const detailLink = {
    pathname: linkHref,
    search:
      fromCategory && fromCategory !== 'Todos'
        ? `?category=${encodeURIComponent(fromCategory)}`
        : '',
    state: fromCategory ? { fromCategory } : undefined
  }

  return (
    <div className='press_articles-container_article'>
      <div className='press_articles-container_article-image'>
        <img src={imageSrc} alt={`Imagen del articulo: ${title}`} />
        {category && (
          <span className={`article-category article-category--${category.toLowerCase()}`}>
            {category}
          </span>
        )}
      </div>

      <div className='press_articles-container_article-content'>
        <p>{title}</p>
        {date && <p className='article-date'>{formatDateES(date)}</p>}
        {isExternal || isAssetFile(url) ? (
          <a href={linkHref} target='_blank' rel='noreferrer'>
            Leer Articulo completo
            <span className='arrow'>&rarr;</span>
          </a>
        ) : (
          <Link to={detailLink}>
            Leer Articulo completo
            <span className='arrow'>&rarr;</span>
          </Link>
        )}
      </div>
    </div>
  )
}
